import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SaveImage"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 15.75H18V14.25H20.25V3.75H9.75V6H8.25V3.75C8.25 2.92157 8.92157 2.25 9.75 2.25H20.25C21.0784 2.25 21.75 2.92157 21.75 3.75V14.25C21.75 15.0784 21.0784 15.75 20.25 15.75ZM16.17 11.325L13.56 8.0625C13.2755 7.70721 12.8451 7.50028 12.39 7.5H3C2.17157 7.5 1.5 8.17157 1.5 9V21C1.5 21.8284 2.17157 22.5 3 22.5H15C15.8284 22.5 16.5 21.8284 16.5 21V12.2625C16.4997 11.9216 16.3833 11.5909 16.17 11.325ZM11.25 9H6.75V11.25H11.25V9ZM11.25 21H6.75V16.5H11.25V21ZM12.75 16.5V21H15V12.2625L12.75 9.45V11.25C12.75 12.0784 12.0784 12.75 11.25 12.75H6.75C5.92157 12.75 5.25 12.0784 5.25 11.25V9H3V21H5.25V16.5C5.25 15.6716 5.92157 15 6.75 15H11.25C12.0784 15 12.75 15.6716 12.75 16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SaveImage.vue"]]);
